<template>
    <div class="page-content login-cover">
        <!-- Main content -->
        <div class="content-wrapper">
            <!-- Content area -->
            <div class="content d-flex justify-content-center align-items-center">
                <!-- Login form -->
                <form class="login-form wmin-sm-400">
                    <div class="card mb-0">
                        <div class="tab-content card-body">
                            <div class="tab-pane fade" :class="{active: tab === 'login', show: tab === 'login'}" id="login-tab1">
                                <div class="alert bg-primary" v-if="running.social" style="margin-top:10px">Redirecting... </div>
                                <template v-if="!running.social">
                                    <div class="form-group text-center text-muted content-divider">
                                        <span class="px-2">sign in with password</span>
                                    </div>
                                    <div class="form-group form-group-feedback form-group-feedback-left">
                                        <input v-model="login.password" type="password" class="form-control" placeholder="Password">
                                        <div class="form-control-feedback">
                                            <i class="icon-lock2 text-muted"></i>
                                        </div>
                                    </div>
                                    <div class="form-group d-flex align-items-center">
                                        <!-- <div class="form-check mb-0">
                                        <label class="form-check-label">
                                            <div class="uniform-checker"><span class="checked"><input type="checkbox" name="remember" class="form-input-styled" checked="" data-fouc=""></span></div>
                                            Remember
                                        </label>
                                    </div> -->
                                    </div>
                                    <div class="form-group">
                                        <button :class="{'loading-mask': running.login}" @click="loginEmail($event)" class="btn btn-primary btn-block legitRipple">Sign in</button>
                                    </div>
                                    <!--  <div class="form-group text-center text-muted content-divider">
                                        <span class="px-2"><span @click="tab = 'register'" style="text-decoration: underline; cursor: pointer">register here</span></span>
                                    </div> -->
                                    <div class="alert bg-success" v-if="success">{{success}}</div>
                                    <div class="alert bg-danger" v-if="error">{{error}}</div>
                                </template>
                                <!-- <div class="form-group text-center text-muted content-divider">
                                    <span class="px-2">Don't have an account?</span>
                                </div>

                                <div class="form-group">
                                    <a href="#" class="btn btn-light btn-block legitRipple">Sign up</a>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </form>
                <!-- /login form -->
            </div>
            <!-- /content area -->
        </div>
        <!-- /main content -->
    </div>
</template>
<script>
export default {
    data() {
        return {
            tab: 'login',
            login: {
                email: null,
                password: null
            },
            register: {
                email: '',
                password: '',
                repeatPassword: ''
            },
            success: '',
            error: '',
            running: {
                password: false,
                login: false,
                register: false,
                social: false
            }
        }
    },
    methods: {
        resetPassword(event) {
            event && event.preventDefault()
            if (!this.login.email) {
                return this.error = 'Please provide an email'
            }

            this.error = ''
            this.success = ''

            this.running.password = true
            this.$api.postReq('user/remind_password', {
                email: this.login.email
            }).then(res => {
                this.running.password = false
                this.success = 'Check your email for instructions'
            }).catch(res => {
                this.running.password = false

                var m = res.body.message
                this.error = 'We couldn`t find you account, perhaps you`ve logged in using social account?'
            })
        },
        loginEmail(event) {
            event && event.preventDefault()
            if (!this.login.password) {
                return this.error = 'Please provide a password'
            }

            this.error = ''
            this.success = ''

            this.running.login = true
            this.$api.postReq('authenticate', {
                password: this.login.password
            }).then(res => {
                this.running.login = false
                var m = res.body.message
                if (res.body.status) {
                    this.$api.area = 'restricted'
                    this.refreshUser(() => {
                        if (this.$storage.acl === 'admin') {
                            this.$router.push({ name: 'domains' })
                        } else {
                            this.$router.push({ name: 'settings' })
                        }
                    })
                } else {
                    if (m === 'password_invalid') {
                        this.error = 'Password invalid'
                    }
                    if (m === 'user_not_found') {
                        this.error = 'User with given email not found'
                    }
                }
            }).catch(res => {
                this.error = 'Password invalid'
                this.running.login = false
            })
        },

    },
    mounted() {
        this.$api.area = 'public'

        if (this.$route.query.tab === 'r') {
            this.tab = 'register'
        }

        if (document.location.href.indexOf('localhost:8080') >= 0) {
            this.login.password = '123456'
        }
    }
}
</script>
<style>
.page-content {
    min-height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/Auth.vue